import { FETCH_LEAD, FETCH_LEADS } from './PanelActions'

const INITIAL_STATE = {
  leads: [],
  triggers: [],
  editingLead: {},
  filters: {},
  attendants: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LEADS.SUCCESS:
      return {
        ...state,
        leads: action.payload.data.data,
        triggers: action.payload.data.triggers,
        filters: action.payload.filters,
      }
    case FETCH_LEAD.SUCCESS:
      return {
        ...state,
        editingLead: action.payload.data?.data,
        attendants: action.payload.data?.attendants,
      }
    default:
      return state
  }
}
